import { FC } from 'react';
import { CloseCross } from '../../atoms/icons';
import { NoStoresError } from '../storeLocator/NoStoresError';
import { Drawer } from '../../molecules/drawer/Drawer';
import Notification from '../../atoms/notification';
import PrimaryLoader from '../../atoms/primaryLoader/PrimaryLoader';
import FindStoreForm from './FindStoreForm';
import StoreListItem from './StoreListItem';

import { buttonCloseSize, stylesDrawer } from './options';
import { FindStoreDrawerProps } from './types';

import styles from './FindStoreDrawer.module.scss';
import { useFindStore } from '@srcDS/hooks/useFindStore';

const FindStoreDrawer: FC<FindStoreDrawerProps> = ({
  showDrawer = false,
  setShowDrawer = null,
  sizeOptions = [],
  selectedSize = null,
  handleSetSelectedStore,
  register,
  onChangeVariant,
  setActiveOption,
  activeOptions,
  selectVariant,
  isSelectingSize,
  selectedStore,
  setValue,
  shouldHideClickCollect,
  setStoreList,
}) => {
  const {
    emptyError,
    loadingStores,
    locationError,
    postCodeValue,
    filteredStores,
    isMobile,
    loading,
    preferredPostcode,
    getUserPosition,
    handleChangeVariant,
    handleGetStoreList,
    setLocationError,
    setFilteredStores,
  } = useFindStore({
    isNewVersionOfFindStore: true,
    showDrawer,
    selectedStore,
    selectedSize,
    activeOptions,
    onChangeVariant,
    setStoreList,
  });

  return (
    <div>
      {showDrawer && (
        /*@ts-ignore*/
        <Drawer
          showHeader={false}
          onClose={() => setShowDrawer(false)}
          shown={showDrawer}
          width={isMobile ? null : 497}
          position="right"
          customClasses={stylesDrawer}
        >
          <div className={styles.container}>
            <div className={styles.closeButtonWrapper} onClick={() => setShowDrawer(false)}>
              {/*@ts-ignore*/}
              <CloseCross colour="#000" {...buttonCloseSize} />
            </div>
            <h2 className={styles.title}>Find in store</h2>
            <p className={styles.desc}>Please select a size and enter your postcode to view store availability.</p>
            <FindStoreForm
              loading={loading}
              preferredPostcode={preferredPostcode}
              getUserPosition={getUserPosition}
              selectedSize={selectedSize}
              sizeOptions={sizeOptions}
              onSubmitAction={handleGetStoreList}
              sizeRegister={register}
              onChangeVariant={handleChangeVariant}
              setActiveOption={setActiveOption}
              isSelectingSize={isSelectingSize}
              selectVariant={selectVariant}
              setFilteredStores={setFilteredStores}
              setLocationError={setLocationError}
              setSizeValue={setValue}
            />
            {loadingStores && (
              <div className={styles.loadingWrapper}>
                <div className={styles.loader}>
                  <PrimaryLoader mode="segment" size={40} />
                </div>
              </div>
            )}

            <div>
              {filteredStores.length
                ? filteredStores.map((store) => (
                    <StoreListItem
                      store={store}
                      key={store.id}
                      skuId={activeOptions?.sku}
                      selectedStore={selectedStore}
                      setShowDrawer={setShowDrawer}
                      setSelectedStore={handleSetSelectedStore}
                      shouldHideClickCollect={shouldHideClickCollect}
                    />
                  ))
                : null}
              {!filteredStores.length && emptyError && postCodeValue && !loadingStores ? (
                <NoStoresError postCode={postCodeValue} hideViewAll />
              ) : null}
              {locationError && !loadingStores && <Notification type="error" message={locationError} />}
            </div>
          </div>
        </Drawer>
      )}
    </div>
  );
};

export default FindStoreDrawer;
